function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#ac893a;}.cls-3{stroke:#ac893a;stroke-width:2.92px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "menu_grafika_lekcjapro\u0301bna");

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  transform: "translate(23.435)",
  points: "59.57 0 59.57 146.3 93.56 146.3 93.56 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m100 115.37a76.14 76.14 0 1 0 76.14 76.14 76.1 76.1 0 0 0-76.14-76.14zm0 116a39.82 39.82 0 1 1 39.82-39.82 39.78 39.78 0 0 1-39.82 39.78z"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 100,
  cy: 191.51,
  r: 39.82
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 100,
  cy: 190.86,
  r: 39.82
});

var SvgLekcjaProbna = function SvgLekcjaProbna(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 200 268",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLekcjaProbna, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lekcja_probna.d14fcefd.svg";
export { ForwardRef as ReactComponent };